import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
	selector: 'app-auth-forgot-pss-dialog',
	templateUrl: './auth-forgot-pss-dialog.component.html',
	styleUrls: ['./auth-forgot-pss-dialog.component.scss'],
})
export class AuthForgotPssDialogComponent implements OnInit {
	pss_reset_from_group: FormGroup = this.form_service.auth_pss_reset_form_group;
	error_matcher: FormErrorStateMatcher = this.form_service.matcher;
	is_pss_request_running: boolean = false;

	constructor(
		private form_service: FormService,
		private auth_service: AuthService,
		private dialog_ref: MatDialogRef<AuthForgotPssDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: any,
	) {}

	ngOnInit(): void {
		this.pss_reset_from_group.reset();
	}

	onCloseClick(): void {
		this.dialog_ref.close();
	}

	onPssRequestClick(): void {
		if (this.isFormValid()) {
			const username: string = this.pss_reset_from_group.get(
				this.form_service.email_label,
			)?.value;
			this.forgotPassword(username);
		}
	}

	forgotPassword(username: string): void {
		this.is_pss_request_running = true;
		this.auth_service.forgotPassword(username).subscribe({
			next: response => {
				this.dialog_ref.close({
					success: true,
					username: username,
				});
				this.is_pss_request_running = false;
			},
			error: error => {
				this.dialog_ref.close({ error: error });
				this.is_pss_request_running = false;
			},
		});
	}

	isFormValid(): boolean {
		return this.form_service.validateForm(this.pss_reset_from_group);
	}
}
